import React from 'react';
import { Typography } from '@mui/material';

import { v2Colors } from '../../design/theme';

export default function CheckoutSectionHeading({ children, sx }) {
  return (
    <Typography
      component="h2"
      sx={[
        {
          fontWeight: 700,
          fontSize: { xs: '1.2rem', sm: '1.35rem' },
          lineHeight: 1.25,
          color: v2Colors.heading,
          mb: 1.5,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Typography>
  );
}
